import React, { useState } from 'react';
import { ClipboardListIcon, FileTextIcon, DownloadIcon, CalendarIcon, FilterIcon, SearchIcon, SettingsIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, FileIcon, PieChartIcon, BoxIcon, WrenchIcon, LayoutGridIcon } from 'lucide-react';
export const Reporting: React.FC = () => {
  const templates = [{
    id: 1,
    title: 'Laporan Per Item Aset',
    desc: 'Detail lengkap spesifikasi, lokasi, dan riwayat per aset individual.',
    icon: <BoxIcon size={24} className="text-blue-600" data-id="element-2762" />,
    color: 'bg-blue-50 border-blue-200'
  }, {
    id: 2,
    title: 'Laporan Per Kategori',
    desc: 'Rekapitulasi aset berdasarkan kategori (Hardware, Software, Kendaraan, dll).',
    icon: <LayoutGridIcon size={24} className="text-purple-600" data-id="element-2763" />,
    color: 'bg-purple-50 border-purple-200'
  }, {
    id: 3,
    title: 'Laporan Per Jenis Peralatan',
    desc: 'Breakdown mendalam berdasarkan jenis dan tipe spesifik peralatan.',
    icon: <WrenchIcon size={24} className="text-orange-600" data-id="element-2764" />,
    color: 'bg-orange-50 border-orange-200'
  }, {
    id: 4,
    title: 'Laporan Usia Peralatan',
    desc: 'Analisis umur aset, depresiasi, dan prediksi waktu penggantian.',
    icon: <ClockIcon size={24} className="text-red-600" data-id="element-2765" />,
    color: 'bg-red-50 border-red-200'
  }, {
    id: 5,
    title: 'Laporan Barang Baik',
    desc: 'Daftar inventaris aset dengan kondisi baik dan status aktif.',
    icon: <CheckCircleIcon size={24} className="text-green-600" data-id="element-2766" />,
    color: 'bg-green-50 border-green-200'
  }, {
    id: 6,
    title: 'Laporan Barang Rusak',
    desc: 'Daftar aset rusak, kritis, atau memerlukan perawatan segera.',
    icon: <AlertCircleIcon size={24} className="text-yellow-600" data-id="element-2767" />,
    color: 'bg-yellow-50 border-yellow-200'
  }, {
    id: 7,
    title: 'Laporan Tahun Pengadaan',
    desc: 'Rekapitulasi aset dikelompokkan berdasarkan tahun anggaran pengadaan.',
    icon: <CalendarIcon size={24} className="text-teal-600" data-id="element-2768" />,
    color: 'bg-teal-50 border-teal-200'
  }, {
    id: 8,
    title: 'Laporan Rekapitulasi Massal',
    desc: 'Ringkasan eksekutif seluruh aset nasional untuk pimpinan.',
    icon: <PieChartIcon size={24} className="text-indigo-600" data-id="element-2769" />,
    color: 'bg-indigo-50 border-indigo-200'
  }];
  const periodicReports = [{
    id: 1,
    period: 'Mingguan',
    type: 'Ringkasan Aset',
    date: '2026-01-06',
    status: 'Selesai',
    format: 'Excel'
  }, {
    id: 2,
    period: 'Bulanan',
    type: 'Rekapitulasi Januari',
    date: '2026-02-01',
    status: 'Selesai',
    format: 'PDF'
  }, {
    id: 3,
    period: 'Triwulan',
    type: 'Laporan Q4 2025',
    date: '2025-12-31',
    status: 'Selesai',
    format: 'PDF+Excel'
  }, {
    id: 4,
    period: 'Tahunan',
    type: 'Laporan Tahunan 2025',
    date: '2026-01-15',
    status: 'Draft',
    format: 'Word'
  }, {
    id: 5,
    period: 'Mingguan',
    type: 'Ringkasan Aset',
    date: '2026-01-13',
    status: 'Proses',
    format: 'Excel'
  }];
  const [scheduleWeekly, setScheduleWeekly] = useState(true);
  const [scheduleMonthly, setScheduleMonthly] = useState(true);
  return <div className="space-y-4" data-id="element-2770">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4" data-id="element-2771">
        <div data-id="element-2772">
          <h1 className="text-xl sm:text-2xl font-bold text-secondary flex items-center" data-id="element-2773">
            <ClipboardListIcon size={24} className="mr-2 text-primary" data-id="element-2774" />
            Pelaporan & Ekspor Data
          </h1>
          <p className="text-gray-500 text-sm mt-1" data-id="element-2775">
            Pusat pembuatan laporan aset dan rekapitulasi data operasional.
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-2776">
          <button className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90 flex items-center text-sm" data-id="element-2777">
            <SettingsIcon size={16} className="mr-2" data-id="element-2778" />
            Pengaturan
          </button>
          <button className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium flex items-center text-sm" data-id="element-2779">
            <DownloadIcon size={16} className="mr-2" data-id="element-2780" />
            Ekspor Massal
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-id="element-2781">
        {/* Main Content */}
        <div className="lg:col-span-2 space-y-4" data-id="element-2782">
          {/* Report Templates */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2783">
            <div className="p-3 border-b border-gray-200 bg-neutral-light flex justify-between items-center" data-id="element-2784">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-2785">
                <FileTextIcon size={18} className="mr-2" data-id="element-2786" />
                Template Laporan Standar
              </h2>
              <div className="flex space-x-2" data-id="element-2787">
                <button className="p-1.5 hover:bg-gray-200 rounded" data-id="element-2788">
                  <SearchIcon size={16} className="text-gray-500" data-id="element-2789" />
                </button>
                <button className="p-1.5 hover:bg-gray-200 rounded" data-id="element-2790">
                  <FilterIcon size={16} className="text-gray-500" data-id="element-2791" />
                </button>
              </div>
            </div>
            <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-2792">
              {templates.map(template => <div key={template.id} className={`border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer group ${template.color}`} data-id="element-2793">
                  <div className="flex items-start justify-between mb-2" data-id="element-2794">
                    <div className="p-2 bg-white rounded-lg shadow-sm" data-id="element-2795">
                      {template.icon}
                    </div>
                    <button className="text-xs font-medium bg-white px-2.5 py-1 rounded border border-gray-200 hover:bg-gray-50 text-gray-700" data-id="element-2796">
                      Generate
                    </button>
                  </div>
                  <h3 className="font-bold text-secondary text-sm mb-1" data-id="element-2797">
                    {template.title}
                  </h3>
                  <p className="text-xs text-gray-600 line-clamp-2" data-id="element-2798">
                    {template.desc}
                  </p>
                </div>)}
            </div>
          </div>

          {/* Periodic Reports */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2799">
            <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-2800">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-2801">
                <ClockIcon size={18} className="mr-2" data-id="element-2802" />
                Riwayat Laporan Berkala
              </h2>
            </div>
            <div className="overflow-x-auto" data-id="element-2803">
              <table className="w-full" data-id="element-2804">
                <thead className="bg-neutral-light" data-id="element-2805">
                  <tr data-id="element-2806">
                    <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2807">
                      Periode
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2808">
                      Jenis Laporan
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2809">
                      Tanggal Generate
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2810">
                      Status
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2811">
                      Format
                    </th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-secondary" data-id="element-2812">
                      Aksi
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200" data-id="element-2813">
                  {periodicReports.map(report => <tr key={report.id} className="hover:bg-neutral-light" data-id="element-2814">
                      <td className="px-4 py-3 text-sm font-medium text-secondary" data-id="element-2815">
                        {report.period}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2816">
                        {report.type}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700" data-id="element-2817">
                        {report.date}
                      </td>
                      <td className="px-4 py-3 text-sm" data-id="element-2818">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${report.status === 'Selesai' ? 'bg-green-100 text-green-800' : report.status === 'Proses' ? 'bg-blue-100 text-blue-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-2819">
                          {report.status}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm" data-id="element-2820">
                        <span className="flex items-center text-xs font-medium text-gray-600 bg-gray-100 px-2 py-1 rounded w-fit" data-id="element-2821">
                          <FileIcon size={12} className={`mr-1 ${report.format.includes('Excel') ? 'text-green-600' : report.format.includes('PDF') ? 'text-red-600' : 'text-blue-600'}`} data-id="element-2822" />
                          {report.format}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm" data-id="element-2823">
                        {report.status === 'Selesai' ? <button className="text-accent-info hover:underline text-xs" data-id="element-2824">
                            Download
                          </button> : report.status === 'Draft' ? <button className="text-accent-info hover:underline text-xs" data-id="element-2825">
                            Edit
                          </button> : <span className="text-gray-400 text-xs" data-id="element-2826">-</span>}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="px-4 py-3 border-t border-gray-200 text-center" data-id="element-2827">
              <button className="text-sm text-accent-info font-medium hover:underline" data-id="element-2828">
                Lihat Semua Riwayat
              </button>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="space-y-4" data-id="element-2829">
          {/* Export Options */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2830">
            <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-2831">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-2832">
                <DownloadIcon size={18} className="mr-2" data-id="element-2833" />
                Format Ekspor Cepat
              </h2>
            </div>
            <div className="p-3 space-y-2" data-id="element-2834">
              {[{
              name: 'Microsoft Excel',
              ext: '.xlsx',
              color: 'green'
            }, {
              name: 'Microsoft Word',
              ext: '.docx',
              color: 'blue'
            }, {
              name: 'PowerPoint',
              ext: '.pptx',
              color: 'orange'
            }, {
              name: 'PDF Document',
              ext: '.pdf',
              color: 'red'
            }].map(fmt => <button key={fmt.ext} className={`w-full flex items-center justify-between p-3 border border-${fmt.color}-200 bg-${fmt.color}-50 rounded-lg hover:bg-${fmt.color}-100 transition-colors`} data-id="element-2835">
                  <div className="flex items-center" data-id="element-2836">
                    <div className={`bg-${fmt.color}-100 p-2 rounded-md mr-3`} data-id="element-2837">
                      <FileIcon size={18} className={`text-${fmt.color}-600`} data-id="element-2838" />
                    </div>
                    <div className="text-left" data-id="element-2839">
                      <div className={`font-bold text-${fmt.color}-800 text-sm`} data-id="element-2840">
                        {fmt.name}
                      </div>
                      <div className={`text-xs text-${fmt.color}-600`} data-id="element-2841">
                        {fmt.ext} format
                      </div>
                    </div>
                  </div>
                  <DownloadIcon size={16} className={`text-${fmt.color}-600`} data-id="element-2842" />
                </button>)}
            </div>
          </div>

          {/* Scheduled Reports */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-2843">
            <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-2844">
              <h2 className="font-bold text-secondary flex items-center" data-id="element-2845">
                <CalendarIcon size={18} className="mr-2" data-id="element-2846" />
                Jadwal Laporan Otomatis
              </h2>
            </div>
            <div className="p-4 space-y-4" data-id="element-2847">
              <div className="flex items-center justify-between" data-id="element-2848">
                <div data-id="element-2849">
                  <div className="font-medium text-sm text-secondary" data-id="element-2850">
                    Laporan Mingguan
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2851">
                    Setiap Senin, 08:00 WIB
                  </div>
                </div>
                <button onClick={() => setScheduleWeekly(!scheduleWeekly)} className={`w-10 h-5 rounded-full transition-colors relative ${scheduleWeekly ? 'bg-green-400' : 'bg-gray-300'}`} data-id="element-2852">
                  <span className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform ${scheduleWeekly ? 'left-5' : 'left-0.5'}`} data-id="element-2853" />
                </button>
              </div>

              <div className="flex items-center justify-between" data-id="element-2854">
                <div data-id="element-2855">
                  <div className="font-medium text-sm text-secondary" data-id="element-2856">
                    Laporan Bulanan
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-2857">
                    Setiap Tgl 1, 09:00 WIB
                  </div>
                </div>
                <button onClick={() => setScheduleMonthly(!scheduleMonthly)} className={`w-10 h-5 rounded-full transition-colors relative ${scheduleMonthly ? 'bg-green-400' : 'bg-gray-300'}`} data-id="element-2858">
                  <span className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform ${scheduleMonthly ? 'left-5' : 'left-0.5'}`} data-id="element-2859" />
                </button>
              </div>

              <div className="pt-3 border-t border-gray-100" data-id="element-2860">
                <div className="text-xs font-medium text-gray-500 mb-2" data-id="element-2861">
                  PENERIMA LAPORAN
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-2862">
                  <span className="px-2 py-1 bg-gray-100 rounded-full text-xs text-gray-600 flex items-center" data-id="element-2863">
                    deputi5@bin.go.id
                    <button className="ml-1 hover:text-red-500" data-id="element-2864">×</button>
                  </span>
                  <span className="px-2 py-1 bg-gray-100 rounded-full text-xs text-gray-600 flex items-center" data-id="element-2865">
                    minlog@bin.go.id
                    <button className="ml-1 hover:text-red-500" data-id="element-2866">×</button>
                  </span>
                  <button className="px-2 py-1 border border-dashed border-gray-300 rounded-full text-xs text-gray-400 hover:text-primary hover:border-primary" data-id="element-2867">
                    + Tambah
                  </button>
                </div>
              </div>

              <div className="bg-yellow-50 p-3 rounded-lg border border-yellow-100" data-id="element-2868">
                <div className="flex items-start" data-id="element-2869">
                  <CalendarIcon size={14} className="text-yellow-600 mt-0.5 mr-2 flex-shrink-0" data-id="element-2870" />
                  <div data-id="element-2871">
                    <div className="text-xs font-medium text-yellow-800" data-id="element-2872">
                      Jadwal Berikutnya
                    </div>
                    <div className="text-sm font-bold text-secondary" data-id="element-2873">
                      Senin, 20 Jan 2026
                    </div>
                    <div className="text-xs text-gray-600" data-id="element-2874">
                      Laporan Mingguan (Excel)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};